
import React, { Component, memo } from "react";
import { connect } from "react-redux";
import { axiosCmsAPI } from "../../axios";

import {
  getEvent,
	showLoader,
	hideLoader,
	setSignupModalStatus,
} from "../../actions";
import { REGISTRATION_STATUS } from "../../actions/actionTypes";
import { updateFormElements, checkFormValid } from "../../util/FormHelper";
import RegisterConfig from "../../components/formsConfig/EventRegisterConfig";
import {
	followButtonClicked,
	unFollowButtonClicked,
	IsEmpty,
	objectToArray,
	getParameterByName,
	formatDate,
	formatTime,
	sanitizeAndProcessHtml
} from "../../util/commonFunctions";
import { handleActionError } from "../../util/error";

import { Navigation } from "../AllEventPage/navigation";
import { LoaderComponent } from '../../components/loader';
import EventRegister from "../../components/forms/EventRegister";
import SpeakersHorizontalWideCard from "./speakersList/SpeakersList";

import '../../../client/event.css';
import EventQuestionPopup from "../../components/eventQuestion/questionPopup";
import TopicsList from "./topicsList/TopicsList";
import RelatedObjectsSlider from "../../components/shared/RelatedObjectsSlider";

let hierarchyArr = [
	{
		id: 1,
		name: 'all events',
		description: 'event list description',
		metaDescription: 'event list meta desc',
		url: "/all-events",
	},
  {
		id: 1,
		name: 'event',
		description: 'event list description',
		metaDescription: 'event list meta desc',
    url: "",
	},
]


class Event extends Component {
  constructor(props) {
    super(props);
    this.state = {
			title: "",
			registrationStatus: REGISTRATION_STATUS._WAITING,
			eventId: null,
			...{ RegisterConfig },
			btnDisabled: true,
			isUpdated: false,
			isUpcoming: false,
			showQuestionPopup: false,
    };
  }

	quesModalToggle(value) {
   this.setState({showQuestionPopup: value});
  }

	componentDidMount = () => {
		this.state.eventId = getParameterByName('eventId');
		if (this.props.event){
			console.log('this.props.event', this.props.event)
			this.state.isUpcoming = new Date() < new Date(this.props.event.event_date);
		} else {
			this.props.getEvent(this.state.eventId);
		}
		this.state.title = this.formatEventName(window.location.pathname);
	}

	openSigninModalPopup = (formName = "signin") => {
		this.props.setSignupModalStatus(true, formName);
	};

	formatEventName(pathname) {
		const eventSlug = pathname.split('/').pop();
		const formattedEventName = eventSlug
			.split('-')
			.map(word => word.charAt(0).toUpperCase() + word.slice(1))
			.join(' ');
		return formattedEventName;
	}

	followObject = (objectId, objectType) => {
		const isLoggedin = !IsEmpty(localStorage.getItem("token"))

		if (isLoggedin) {
				if (objectType == "company") {
						followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), objectId);
				} else if (objectType == "expert") {
						followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
				} else if (objectType == "topic") {
						followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
				} else if (objectType == "series") {
						followButtonClicked(this.followButtonClickedRespHandler, localStorage.getItem("token"), null, null, null, objectId);
				}
		} else {
				this.openSigninModalPopup("signin");
		}
	}

	unFollowObject = (objectId, objectType) => {
		if (objectType == "company") {
				unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), objectId);
		} else if (objectType == "expert") {
				unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, objectId);
		} else if (objectType == "topic") {
				unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, objectId);
		} else if (objectType == "series") {
				unFollowButtonClicked(this.unFollowButtonClickedRespHandler, localStorage.getItem("token"), null, null, null, objectId);
		}
	}

	componentDidUpdate = () => {
		if(this.props.userProfile && this.state.isUpcoming) {
			if(!this.state.isUpdated) {
				if(this.state.RegisterConfig.firstName.value !== this.props.userProfile.firstName) {
					this.state.RegisterConfig.firstName.value = this.props.userProfile.firstName;
				}
				if(this.state.RegisterConfig.lastName.value !== this.props.userProfile.lastName) {
					this.state.RegisterConfig.lastName.value = this.props.userProfile.lastName;
				}
				if(this.state.RegisterConfig.email.value !== this.props.userProfile.email) {
					this.state.RegisterConfig.email.value = this.props.userProfile.email;
				}				
				this.autoFillUserInfo();
				this.state.isUpdated = true;
			}
		}
	}

	autoFillUserInfo = () => {
    objectToArray(this.state.RegisterConfig).map((value) => {
      let input = document.getElementById(value.id);
      input?.focus();
			input?.blur();
    });
	}

	registerHandler = (extraPayload) => {
		let payload = {
			"email": this.state.RegisterConfig.email.value,
			"first_name": this.state.RegisterConfig.firstName.value,
			"last_name": this.state.RegisterConfig.lastName.value,
			"phone": this.state.RegisterConfig.phone.value === "" ? null : this.state.RegisterConfig.phone.value,
			"responses": extraPayload && extraPayload.length > 0 ? extraPayload.map(ans => {return {question: ans.question, answer: ans.response}}) : [],
		}
		this.setState({
			registrationStatus: REGISTRATION_STATUS._LOADING, 
		});
		axiosCmsAPI.post(`/events/register/${this.state.eventId}`, {
			"data": payload
		})
		.then(res => {
			if(res.status === 200) {
				this.setState({
					registrationStatus: REGISTRATION_STATUS._SUCCESS, 
				});
			}
		})
		.catch(err => {
			this.setState({
				registrationStatus: REGISTRATION_STATUS._FAILURE, 
			});
			handleActionError("Error subscribing to webinar:", err);
		});
}

	registerClickHandler = (questions) => {
		if(this.state.showQuestionPopup && questions && questions.length > 0) {
			this.setState({
				registrationStatus: REGISTRATION_STATUS._SUCCESS, 
			});
			this.registerHandler(questions);
			this.quesModalToggle(false);
		}else {
			if(this.props.event.event_questions && this.props.event.event_questions.length > 0) {
				this.quesModalToggle(true);
			} else {
				this.registerHandler();
			}
		}	
  };

	onChangeHandler = (event, formName) => {
    const updatedFrom = updateFormElements(
      event,
      event.target.getAttribute("type"),
      this.state[formName]
    );
    this.setState({
      [formName]: updatedFrom,
      btnDisabled: !checkFormValid(updatedFrom).formValid
    });
  };

	onBlurHandler = (event, formName) => {
    this.setState({
      [formName]: updateFormElements(event, "validation", this.state[formName]),
      btnDisabled: !checkFormValid(this.state[formName]).formValid
    });
  };

	openSigninModalPopup = (requestedForm) => {
    this.props.setSignupModalStatus(true, requestedForm);
  };

  render() {
    return (
			<React.Fragment>
				<div className="contentWhite event-page">
					{this.props.event &&
						<div className="container">
							<section className="event-navigation">
								<Navigation
									hierarchy={hierarchyArr}
									isEventCrumb={true}
									eventName={this.props.event?.title}
									imageUrl={this.props.event?.event_image_file_base?.path}              
								/>
								<h1 className="navigation-title">{this.props.event.title}</h1>
							</section>
							<section
								className="event-container"
								ref={this.lazyLoadContainer}
							>
								<div className="event-header col-md-12 row">
									<div className="col-md-8">
										<img src={this.props.event?.event_image_file_base?.path} alt={"Ausbiz event: " + this.props.event?.title + " thumbnail"}/>
										<p className="event-date"><i></i>{formatDate(this.props.event.event_date)}  ( {formatTime(this.props.event.start_time)} ~ {formatTime(this.props.event.end_time)} )</p>
									</div>
									<div className="col-md-4">
										{this.state.isUpcoming && 
											<div className="register-form-container">
												<EventRegister
													status={this.state.registrationStatus}
													form={objectToArray(this.state.RegisterConfig)}
													formName="RegisterConfig"
													btnDisabled={this.state.btnDisabled}
													onChangeHandler={this.onChangeHandler}
													onBlurHandler={this.onBlurHandler}
													registerHandler={this.registerClickHandler}
												/>											
											</div>
										}
									</div>
								</div>
								{this.props.event.description &&
									<div className="col-md-8 event-detail">
										<div dangerouslySetInnerHTML={{__html: sanitizeAndProcessHtml(this.props.event.description)}}></div>
									</div>
								}
								{this.props.event.about &&
									<div className="col-md-12 event-detail">
										<h1>About the Event</h1>
										<div dangerouslySetInnerHTML={{__html: sanitizeAndProcessHtml(this.props.event.about)}}></div>
									</div>
								}
								{this.props.event?.key_points_body && typeof(this.props.event?.key_points_body) === "string" && 
									<div className="col-md-12 event-detail">
										<h1>{this.props.event?.key_points_title && this.props.event?.key_points_title !== "" ? this.props.event?.key_points_title : "Key Points of the Event"}</h1>
										{this.props.event?.key_points_body && <div dangerouslySetInnerHTML={{__html: sanitizeAndProcessHtml(this.props.event?.key_points_body)}}></div>}
									</div>
								}
								
								<div className="col-md-12 speakers event-detail">
									<h1>Speakers</h1>
									{this.props.speakers &&							
										<SpeakersHorizontalWideCard
											experts={this.props.speakers}
											parentProps={this.props}
											followObject={this.followObject}
											unFollowObject={this.unFollowObject}
										/>
									}
								</div>
								<div className="related-items-container event-detail">
									{this.props.event?.companies && this.props.event?.companies.length > 0 && 
										<>
											<RelatedObjectsSlider
												data={
													{
														companies: this.props.event.companies
													}
												}
												isEventUI={true}
												openSigninModalPopup={this.openSigninModalPopup}
											/>
										</>
									}
									<TopicsList 
										secondaryTopics={this.props.event?.topics} 
										openSigninModalPopup={this.openSigninModalPopup}
									/>
								</div>
								{this.props.event.terms_and_conditions && 
									<div className="col-md-12 event-details">
										<h1>Terms and Conditions</h1>
										<div dangerouslySetInnerHTML={{__html: sanitizeAndProcessHtml(this.props.event.terms_and_conditions)}}></div>
									</div>
								}
							</section>
						</div>
					}
					<EventQuestionPopup 
						allQues={this.props.event.event_questions.map(question => {
							return	{...question.question, validResponses: question.question?.responses?.split(","), isMandatory: question.is_mandatory}
						})}
						showQuestionPopup={this.state.showQuestionPopup}
						questionPopupClosedHandler={(value) => this.quesModalToggle(value)}
						questionSuccessHandler={(value) => this.registerClickHandler(value)}
					/>
					<LoaderComponent isLoading={this.props.isEventLoading}/>
				</div>
			</React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
		userProfile: state.auth.userProfile,
		event: state.eventDetails.event,
		isEventLoading: state.eventDetails.isEventLoading,
		speakers: state.eventDetails.expertsList,
		currentLanguage: state.language.currentLanguage
  };
};

function mapDispatchToProps(dispatch) {
  return {
		hideLoader: () => dispatch(hideLoader()),
		showLoader: () => dispatch(showLoader()),
		getEvent: (eventId, currentLanguage) => dispatch(getEvent(eventId, currentLanguage)),
		setSignupModalStatus: (status, requestedForm) => dispatch(setSignupModalStatus(status, requestedForm)),
	}
}

function loadData(store, match, query) {
	let seriesId = query.eventId;
	const currentLanguage = store.getState().language.currentLanguage;
  let actionArray = [
    store.dispatch(getEvent(seriesId, currentLanguage)),
  ];
  return actionArray;
}

export default { loadData, 
	component: 
    connect(mapStateToProps, mapDispatchToProps)(memo(Event))
};